var exports = {
  "kL": "RichPresenceCard.module__container___R29MSG",
  "wx": "RichPresenceCard.module__header___R29MSG",
  "zI": "RichPresenceCard.module__headerDot___R29MSG",
  "Qs": "RichPresenceCard.module__content___R29MSG",
  "P0": "RichPresenceCard.module__iconWrapper___R29MSG",
  "pq": "RichPresenceCard.module__info___R29MSG",
  "UU": "RichPresenceCard.module__name___R29MSG",
  "zH": "RichPresenceCard.module__details___R29MSG",
  "wk": "RichPresenceCard.module__state___R29MSG",
  "kB": "RichPresenceCard.module__time___R29MSG",
  "DB": "RichPresenceCard.module__timeIcon___R29MSG",
};

module.exports = exports;
